/**
 * Persistência de transações "em confirmação" para reconciliar após reload/fechar.
 * Se o usuário fechar ou recarregar antes de receber o receipt, na próxima abertura
 * a app verifica na chain se a tx foi confirmada e registra a taxa pendente.
 */

const STORAGE_KEY = 'pcp_pending_tx_reconcile';

/**
 * @typedef {{
 *   txHash: string;
 *   chainId: string;
 *   feeUSD: number;
 *   token: string;
 *   networkName: string;
 *   createdAt: number;
 * }} PendingTxReconcileEntry
 */

/**
 * @returns {PendingTxReconcileEntry[]}
 */
export function getPendingTxReconcileList() {
  if (typeof window === 'undefined') return [];
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

/**
 * @param {PendingTxReconcileEntry} entry
 */
export function addPendingTxReconcile(entry) {
  if (typeof window === 'undefined' || !entry?.txHash) return;
  try {
    const list = getPendingTxReconcileList();
    if (list.some((e) => e.txHash === entry.txHash)) return;
    list.push({
      ...entry,
      createdAt: entry.createdAt ?? Date.now(),
    });
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  } catch (_) {}
}

/**
 * @param {string} txHash
 */
export function removePendingTxReconcile(txHash) {
  if (typeof window === 'undefined' || !txHash) return;
  try {
    const list = getPendingTxReconcileList().filter((e) => e.txHash !== txHash);
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  } catch (_) {}
}
